import gql from 'fraql'

const motivateAccountingQueries = {
  LIST_ACCOUNTING_WORKERS: gql`
    query accountingWorkersGetlist ($day: Date, $showOnlyOpened: Boolean) {
      accountingWorkersGetlist (day: $day, showOnlyOpened: $showOnlyOpened)  {
        nodes {
          id
          timeOpened
          idWorker
          workerByIdWorker {
            lastName
            firstName
          }
        }
      }
    }
  `,
  COOKER_CAME_ON_WORK: gql`
  mutation cookerCameOnWork ($codeCooker: String!) {
    cookerCameOnWork (input: {codeCooker: $codeCooker})  {
      boolean
    }
  }`,
  COOKER_LEAVES_WORK: gql`
  mutation cookerLeavesWork ($idCooker: Int!) {
    cookerLeavesWork (input: {idCooker: $idCooker})  {
      boolean
    }
  }`,
  LIST_MOTIVATE_PERCENTS: gql`
  query {
    tableMotivateCookPercents {
      nodes {
        percentMax,
        percentTarget,
        rewardPercent
      }
    }
  }
  `
}

export default motivateAccountingQueries



// WEBPACK FOOTER //
// ./src/constants/graphqlAccounting.js